import * as React from 'react';
import styled from 'styled-components';
import { Icon } from '@agilepoint/wat-react-ux';
import { useTranslate } from '@agilepoint/wat-react';
import { IHelpLinks } from 'types/config';
import { useConfigScopeSelectors } from 'modules/core/scopes';
import { commonStyles } from '../style-literals';

export interface IHelpLinkProps {
    id?: keyof IHelpLinks;
}

const LinkWrapper = styled.a`
    font-size: 0px;
    display: inline-flex;
    ${commonStyles.outlineColor};
    .ap-icon {
        fill: ${({ theme: { semantics: { palette } } }) => palette.themePrimary};
        :hover{
            opacity: 0.6;
        }
    }
    ${commonStyles.outlineColor}
`;

export const HelpLink = React.memo((props: IHelpLinkProps) => {
    const { id } = props;
    const translate = useTranslate();
    const baseUrl = useConfigScopeSelectors().selectHelpBaseUrl();
    const { selectHelpLinkIdByType } = useConfigScopeSelectors('config');
    const url = React.useMemo(() => {
        const linkId = id && selectHelpLinkIdByType(id);
        return `${baseUrl}${linkId}`;
    }, [baseUrl, id, selectHelpLinkIdByType]);

    const title = translate('app:common.actions.help');

    return (
        <>
            {
                id && <LinkWrapper title={title} href={url} target="_blank" aria-label={title}>
                    <Icon iconName="ap-informaton-round-thick.outline" iconSize="16" ></Icon>
                    {title}
                </LinkWrapper>
            }
        </>
    );
});
